<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('catalogue.newProduct.produitsAssocies') }}
      </p>
    </header>
    <div class="card-article-any has-background-background card-content has-text-centered"
         v-if="isDisabled && !produits.length">
      <br>
      <h1 class="title is-size-4">
        {{ this.$t('catalogue.aucunProduitAssocie')}}
      </h1>
      <p>
        {{ this.$t('catalogue.addProduitAssocie')}}
      </p>
    </div>
    <div class="card-content" v-else>
      <div class="columns">
        <b-field class="column is-4" v-if="isProduitPatrimonial">
          <span class="has-text-default has-text-weight-bold mgr-20px mgt-5px">
            {{ $t('catalogue.default') }}
          </span>
          <b-select :disabled="isDisabled"
                    :placeholder="$t('catalogue.aucunDefaut')"
                    v-model="displayAucunproduitSelectionne"
                    expanded>
            <option value="">{{ $t('catalogue.aucunDefaut') }}</option>
            <option v-for="produitEnfant in listeProduitDefault"
                    :key="produitEnfant.id"
                    :value="produitEnfant.id">
              {{produitEnfant.libelle}}
              <span v-if="societesInformations.length > 1" class="has-text-weight-bold">
                ({{produitEnfant.libelleSociete}})</span>
            </option>
          </b-select>
        </b-field>
        <b-field class="column is-3" v-if="showSelectSociete">
          <span class="has-text-default has-text-weight-bold mgr-20px mgt-5px">
            {{ $t('catalogue.societeSelect') }}
          </span>
          <b-select v-model="societeForGetAll"
                    expanded>
            <option v-for="societe in societeOfUser"
                    :key="societe.societeId"
                    :value="societe.societeId">
              {{societe.libelleSociete}}
            </option>
          </b-select>
        </b-field>
        <b-field class="column is-4" v-if="isDisabled">
          <span class="has-text-default has-text-weight-bold mgr-20px mgt-5px">
            {{ $t('catalogue.dateVisu') }}
          </span>
          <b-datepicker show-week-number
                         nearby-selectable-month-days
                         :value="dateVisualisation"
                         icon="calendar-today"
                         :editable="true"
                         @input="updateDateVisualisation">
        </b-datepicker>
        </b-field>
        <div class="column is-4" v-if="!isDisabled"
             :class="[{'is-offset-1': showSelectSociete && isProduitPatrimonial },
             {'is-offset-4': !showSelectSociete && isProduitPatrimonial},
             { 'is-offset-5' :  showSelectSociete && !isProduitPatrimonial},
              { 'is-offset-8' :  !showSelectSociete && !isProduitPatrimonial}]"
        >
          <button class="button is-primary is-pulled-right mgl-10px"
                  @click="goToEcranAddProduitAssocies">
            {{ $t('catalogue.button.selectProduit') }}
          </button>
          <button class="button is-primary is-pulled-right"
                  @click="ajoutLigneProduit">
            {{ $t('catalogue.button.ajouterProduit') }}
          </button>
        </div>
        <div class="column" v-else>
          <exportExcelButton class="is-pulled-right"
            :perm="permissions.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
      <div v-if="getProduits.length > 0">
        <div class="ligneProduitHeader section-produit">
          <div class="columns is-marginless is-paddingless">
            <div class="label column is-3 has-text-black">
              {{ $t('catalogue.newProduct.produit') }}
            </div>
            <div class="label column is-1-5 has-text-black">
              {{ $t('catalogue.newProduct.quantite') }}
            </div>
            <div class="label column is-1-5 has-text-black">
              {{ $t('catalogue.newProduct.prixUnitaire') }}
            </div>
            <div class="label column is-1-5 has-text-black"
                 v-if="isProduitReseauTempo">
            </div>
            <div class="label column is-1-5 mgr-20px has-text-black">
              {{ $t('catalogue.table.startDate') }}
            </div>
            <div class="label column is-1-5 has-text-black">
              {{ $t('catalogue.table.endDate') }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-article-any has-background-background card-content has-text-centered"
           v-else>
        <h1 class="title is-size-4 mgt-20px">
          {{ this.$t('catalogue.aucunProduitAssocie')}}
        </h1>
        <p>
          {{ this.$t('catalogue.addProduitAssocie')}}
        </p>
      </div>
      <ligne-produit v-for="(item, index) in getProduits"
                     :key="index"
                     :produit="item"
                     :materiel="materiel"
                     :face="face"
                     v-bind="{'societeId':societeForGetAll}"
                     :produit-type="produit.supportCommercial.categorieVente"
                     :isDisabled="isDisabled"
                     :sens="produit.sens"
                     :dateDebutDefault="produitValue ? produitValue.dateDebut : null"
                     :dateFinDefault="produitValue ? produitValue.dateFin: null"
                     @ajoutDropdownProduitDefault="ajoutDropdownProduitDefault"
                     @suppressionLigne="supprimerLigneProduit(index)"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import ligneProduit from '@/components/catalogue/produitGeneral/m_ligneProduit';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import moment from 'moment';
import formatDate from '@/services/general/formatDate';

const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Produit = createNamespacedHelpers('produit');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    breadcrumb: {
      type: Array,
      required: false,
    },
    produitValue: {
      type: Object,
    },
    materiel: {
      type: Object,
    },
    face: {
      type: Object,
    },
    sens: {
      type: String,
    },
    dateVisualisation: {
      type: Date,
      required: false,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  components: {
    ligneProduit,
    exportExcelButton,
  },
  data() {
    return {
      listeProduitDefault: [],
      produits: [],
      societeForGetAll: null,
    };
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeOfUser: 'societeOfUser',
      societesInformations: 'societesInformations',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    showSelectSociete() {
      return this.isProduitPatrimonial
        && this.societeOfUser.length > 1
        && !this.filtrerProduitParSociete;
    },
    getProduits() {
      const dateVisu = moment(this.dateVisualisation);
      const produits = this.produits.filter((produit) => {
        return (!produit.produitEnfant
                || produit.produitEnfant.supportCommercial.societeId === this.societeForGetAll)
              && (!this.isDisabled || !this.dateVisualisation
                  || (!produit.dateFin && dateVisu.isSameOrAfter(moment(produit.dateDebut)))
                  || dateVisu.isBetween(moment(produit.dateDebut), moment(produit.dateFin), 'day', '[]'));
      });
      return produits;
    },
    produitsActif() {
      return this.produits.filter(produit => !produit.archive);
    },
    isProduitPatrimonial() {
      return this.produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_DIVERS
        && this.produit.supportCommercial.categorieVente !== produitConf.CATEGORIE_LOCATION;
    },
    isProduitReseauTempo() {
      return this.produit.supportCommercial.categorieVente === produitConf.CATEGORIE_REGROUPEMENT;
    },
    displayAucunproduitSelectionne: {
      get() {
        if (!this.produitValue || !this.produitValue.produitParDefautId
          || this.produitValue.produitParDefautId.length === 0) return null;
        return this.produitValue.produitParDefautId;
      },
      set(newProduitParDefautId) {
        this.produitValue.produitParDefautId = newProduitParDefautId;
      },
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'produitsassocies',
        typeExport: '',
        filtres: {
          query: {
            produitsParents: [this.produit.id],
            dateVisualisation: formatDate(this.dateVisualisation),
          },
        },
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key]);
      this.societeForGetAll = this.produit.supportCommercial.societeId;
      this.produits = this.produit.liaisonsTarif;
      this.produits.forEach(produit => {
        produit.dateDebut = new Date(produit.dateDebut);
        produit.dateFin = produit.dateFin ? new Date(produit.dateFin) : null;
        if (!produit || !produit.produitEnfant) return;
        if (produit.produitEnfant.supportCommercial.categorieVente
          === produitConf.CATEGORIE_DIVERS) {
          produit.divers = true;
        } else if (produit.produitEnfant.supportCommercial.categorieVente
          === produitConf.CATEGORIE_LOCATION) {
          produit.location = true;
        }
        const isFind = this.listeProduitDefault.find((produitDefault) => {
          return produitDefault.id === produit.produitEnfantId;
        });
        if (!isFind) {
          this.listeProduitDefault.push({
            id: produit.produitEnfantId,
            libelle: produit.libelle,
            libelleSociete: this.getLibelleSociete(
              produit.produitEnfant.supportCommercial.societeId,
            ),
          });
        }
      });
      if (!this.produits.length && !this.isDisabled) {
        this.produits.push({
          input: '',
        });
      }
      this.produits.sort((a, b) => {
        const dateA = new Date(a.dateDebut);
        const dateB = new Date(b.dateDebut);
        return dateB - dateA;
      });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Produit.mapActions({
      updateProduit: 'updateProduit',
      updateSocieteForGetAll: 'updateSocieteForGetAll',
    }),
    async goToEcranAddProduitAssocies() {
      this.updateProduit(this.produit);
      this.updateSocieteForGetAll(this.societeForGetAll);
      await this.$router.push({
        name: 'm.bodac.catalogue-ajoutProduitAssocie',
        params: { breadcrumb: this.breadcrumb, sens: this.sens },
      });
    },
    ajoutLigneProduit() {
      this.produits.unshift({
        input: '',
      });
    },
    ajoutDropdownProduitDefault(idProduit, libelle, type, societeId) {
      const allProductWithId = this.produits.filter(
        produit => produit.produitEnfantId === idProduit,
      );
      if (allProductWithId.length > 1 || !type) return;
      this.listeProduitDefault.push({
        id: idProduit,
        libelle: libelle,
        libelleSociete: this.getLibelleSociete(societeId),
      });
    },
    updateDateVisualisation(newValue) {
      this.$emit('editDateVisualisation', newValue);
    },
    suppressionDopdownProduitDefault(idProduit) {
      const isTheOnlyOne = this.produits.filter((produit) => {
        return produit.produitEnfantId === idProduit;
      });
      if (isTheOnlyOne.length > 0) return;
      const index = this.listeProduitDefault.findIndex((produit) => {
        return produit.id === idProduit;
      });
      if (idProduit === this.produitValue.produitParDefautId) {
        this.produitValue.produitParDefautId = null;
      }
      this.listeProduitDefault.splice(index, 1);
    },
    supprimerLigneProduit(index) {
      const id = this.produits[index].produitEnfantId;
      this.produits.splice(index, 1);
      this.suppressionDopdownProduitDefault(id);
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : '';
    },
  },
};
</script>
